import React from 'react'
import { buildOutcomeCounts } from '../../utils/OutcomeUtils'
import PartyResultMap from '../../models/PartyResultMap'
import Party from '../../models/Party'
import Utilities from '../../utils/Utilities'

import './OutcomeOdds.scss'

interface IProps {
  outcomes: PartyResultMap[]
}

class OutcomeOdds extends React.Component<IProps> {
  public constructor(props: IProps) {
    super(props)
  }

  public render(): JSX.Element {
    const outcomeCounts = buildOutcomeCounts(this.props.outcomes)
    const numOutcomes = this.props.outcomes.length

    const divs = Object.keys(outcomeCounts)
      .filter((partyKey): boolean => {
        const count = outcomeCounts[partyKey]
        return count.majority > 0 || count.majority > 0 || count.tie > 0
      })
      .map(
        (partyKey): JSX.Element => {
          const outcomeCount = outcomeCounts[partyKey]
          const party = Party.fromKey(partyKey)
          const outcomeDivs = Object.keys(outcomeCount)
            .filter((outcome): boolean => {
              return ['majority', 'minority', 'tie'].includes(outcome)
            })
            .map(
              (outcomeKey): JSX.Element => {
                return (
                  <div className="OutcomeCount" key={outcomeKey}>
                    {outcomeKey}:{' '}
                    {Utilities.formatPercent(
                      outcomeCount[outcomeKey] / numOutcomes
                    )}
                  </div>
                )
              }
            )

          return (
            <div
              key={party.key}
              className={`col text-center party-${party.code}`}
            >
              <div className="PartyKey">{party.key}</div>
              {outcomeDivs}
            </div>
          )
        }
      )

    return (
      <div id="OutcomeOdds" className="row my-1">
        <div className="col">
          <div className="row">{divs}</div>
        </div>
      </div>
    )
  }
}

export default OutcomeOdds
